const overlayNode = {
	draw(rc, x, y, node, measure) {
		const {width, childrenMeasures} = measure;
		const {children} = node;

		children.forEach((child, i) => {
			const m = childrenMeasures[i];
			rc.drawNode(rc, x + 0.5 * width - 0.5 * m.width, y, child, m);
		});
	},

	measure(rc, fontInfo, props, node) {
		const childrenMeasures = node.children.map(n =>
			rc.measureNode(rc, fontInfo, props, n)
		);
		const width = Math.max(...childrenMeasures.map(m => m.width));
		const top = Math.max(...childrenMeasures.map(m => m.top));
		const bottom = Math.max(...childrenMeasures.map(m => m.bottom));
		return {
			width,
			top,
			bottom,
			fontInfo,
			childrenMeasures,
		};
	},

	readAloud: {children: true},
};

module.exports = {
	// parsers: {},
	nodes: {
		overlay: overlayNode,
	},
};
